import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from '@/router'
import App from '@/App.vue'
import { ApiError } from '@/lib/api'
import '@/style.css'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.mount('#app')

/**
 * Hardening: suprime o ruído visual de 'Uncaught (in promise) ApiError:
 * Rota não encontrada' enquanto rotas ainda estão em deploy progressivo.
 *
 * O Dashboard faz `Promise.all([fetchAll().catch(() => null), ...])` em
 * todos os pontos — fetches que falham com 404 NÃO devem poluir a consola.
 * IMPORTANTE: este handler SÓ silencia 404s (Rota não encontrada). Qualquer
 * outro erro (5xx, 401, ApiError de mutação) continua normalmente e propaga
 * para o devtools/toast do caller.
 */
window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason
  if (
    reason instanceof ApiError &&
    reason.status === 404 &&
    typeof reason.message === 'string' &&
    reason.message.includes('Rota não encontrada')
  ) {
    if (import.meta.env.DEV) {
      // eslint-disable-next-line no-console
      console.debug('[LupyBot] rota ainda não deployada:', reason.message)
    }
    event.preventDefault()
  }
})
